import React, { useEffect, useState } from 'react';
import { formatValuesForDisplayBasedOnType } from '@shared/utils/strings';
import { makeStyles } from '@material-ui/core';
import { PercentageIndicator } from '@paretogroup/tess';
import { CampaignTableColumn } from '@domain/campaigns/campaign-table/campaign-table.types';

interface Props {
    value: string|number;
    column: CampaignTableColumn;
}

const invertedMetrics = [
    'cost_per_goal',
    'cost',
    'cpc',
    'cpm',
    'cost_per_conversion',
    'cost_per_transaction',
    'cost_per_conversion',
];

export const useStyles = makeStyles(() => ({
    wrapper: {
        width: 'fit-content',
    },
}));

export const ColumnTableComparisonCell = ({
    value = 0, column,
}: Props) => {
    const classes = useStyles();
    const [renderIcon, setRenderICon] = useState<boolean>(true);
    const [numberValue, setValueNumber] = useState<number>();
    const isInversed = invertedMetrics.indexOf(column?.metric?.value) >= 0;

    useEffect(() => {
        if (Number.isNaN(value) || value.toString() === '0') {
            setRenderICon(false);
        } else {
            setRenderICon(true);
            setValueNumber(parseFloat(value.toString()));
        }
    }, [value]);

    const formatNumberDisplay = numberDisplay => `${formatValuesForDisplayBasedOnType(Math.abs(numberDisplay), 'percent')}`;

    const renderOnlyNumber = () => formatValuesForDisplayBasedOnType(value);

    const renderPercentageIndicator = () => (
        <PercentageIndicator
            className={classes.wrapper}
            label={formatNumberDisplay(numberValue)}
            isInversed={isInversed}
            isPositiveNumber={numberValue > 0}
        />
    );

    return renderIcon ? renderPercentageIndicator() : renderOnlyNumber();
};
